import { PartitionSelector } from "domains/partitions/components/partition-selector";
import { Typography } from "@mui/material";
import localisations from "../../../localisation";
import { useCallback } from "react";
import { SelectedPartitionDetails } from "domains/partitions/components/partition-selector/PartitionSelector";

type SelectTargetPartitionStageProps = {
    fieldCompanyId: number;
    fields: {
        targetPartitionDetails?: SelectedPartitionDetails;
    };
    handleFieldChange: (fields: any) => void;
};

export default function SelectTargetPartitionStage(props: SelectTargetPartitionStageProps) {
    const { heading, blurb } = localisations.movementAllocation.stages.selectTargetPartition;
    const { fields, handleFieldChange } = props;

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {heading}
            </Typography>

            <Typography variant="body1" gutterBottom>
                {blurb}
            </Typography>

            <br />
            <PartitionSelector
                fieldCompanyId={props.fieldCompanyId}
                initialPartitionId={fields.targetPartitionDetails?.id}
                onSelected={useCallback((partitionDetails) => handleFieldChange({ targetPartitionDetails: partitionDetails }), [handleFieldChange])}
            />

            <br />
            <br />
        </>
    );
}
